/**
 * Authoring Tool Labels (Frontend Mirror)
 *
 * This mirrors the backend constants for frontend use.
 * Canonical source: api/constants/AuthoringToolLabels.ts
 *
 * The mirror is verified against canonical by
 * test/codegen/AuthoringToolConsistency.test.ts — keep entries in sync.
 *
 * AUTHORING_TOOL_LABELS is currently unused on the front-end (the i18n
 * pipeline uses AUTHORING_TOOL_KEYS to look up locale strings) but is exported
 * here so the drift test has a single, identical shape across packages.
 */

export enum AuthoringTool {
    ADAPT = 'adapt',
    CAPTIVATE = 'captivate',
    CAMTASIA = 'camtasia',
    DOMINKNOW = 'dominknow',
    ISPRING = 'ispring',
    LECTORA = 'lectora',
    RISE = 'rise',
    STORYLINE = 'storyline',
    GOMO = 'gomo',
    EASYG = 'easyg',
    CLARO = 'claro',
    GENERIC = 'generic',
    UNKNOWN = 'unknown',
    NONE = ''
}

export const AUTHORING_TOOL_LABELS: Record<AuthoringTool, string> = {
    [AuthoringTool.ADAPT]: 'Adapt',
    [AuthoringTool.CAPTIVATE]: 'Captivate',
    [AuthoringTool.CAMTASIA]: 'Camtasia',
    [AuthoringTool.DOMINKNOW]: 'dominKnow',
    [AuthoringTool.ISPRING]: 'iSpring',
    [AuthoringTool.LECTORA]: 'Lectora',
    [AuthoringTool.RISE]: 'Rise',
    [AuthoringTool.STORYLINE]: 'Storyline',
    [AuthoringTool.GOMO]: 'GOMO',
    [AuthoringTool.EASYG]: 'EasyG',
    [AuthoringTool.CLARO]: 'Claro',
    [AuthoringTool.GENERIC]: 'Unknown',
    [AuthoringTool.UNKNOWN]: 'Unknown',
    [AuthoringTool.NONE]: 'Unknown'
};

export const AUTHORING_TOOL_KEYS: Record<AuthoringTool, string> = {
    [AuthoringTool.ADAPT]: 'authoringtool_adapt',
    [AuthoringTool.CAPTIVATE]: 'authoringtool_captivate',
    [AuthoringTool.CAMTASIA]: 'authoringtool_camtasia',
    [AuthoringTool.DOMINKNOW]: 'authoringtool_dominknow',
    [AuthoringTool.ISPRING]: 'authoringtool_ispring',
    [AuthoringTool.LECTORA]: 'authoringtool_lectora',
    [AuthoringTool.RISE]: 'authoringtool_rise',
    [AuthoringTool.STORYLINE]: 'authoringtool_storyline',
    [AuthoringTool.GOMO]: 'authoringtool_gomo',
    [AuthoringTool.EASYG]: 'authoringtool_easyg',
    [AuthoringTool.CLARO]: 'authoringtool_claro',
    [AuthoringTool.GENERIC]: 'authoringtool_generic',
    [AuthoringTool.UNKNOWN]: 'authoringtool_unknown',
    [AuthoringTool.NONE]: 'authoringtool_unknown'
};
